import React, { useState, useRef, useEffect } from "react";
import {StoryblokComponent, renderRichText } from "gatsby-source-storyblok"
import * as styles from "./tourItem.module.css"
import { Trans } from "../utils/lang"
import * as stylesAccordion from "./landingAccordion.module.css"

const Accordion = ({ id, heading, content, headColor, contentClass, open}) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  const toggleAccordion = () => {
    const content = contentRef.current;
    if (content.style.height) {
      content.style.height = null;
    } else {
      content.style.height = `${content.scrollHeight}px`;
    }
    setIsOpen(!isOpen);
  }

  // if param open is true toggleAccordion
  useEffect(() => {
    if (open) {
      toggleAccordion();
    }
  }, []);
  
  return (
    <div id={id} className="container max-w-screen-lg mx-auto flex flex-col">
      <div className={`w-full border-black border-t border-b mt-[-1px] ${isOpen ? stylesAccordion.accordionButton : ''}`} 
        style={{backgroundImage: `linear-gradient(to right, transparent, white, ${headColor})`}}>
        <button
          onClick={toggleAccordion}
          className={`py-3 px-4 w-full text-left text-xl font-serif`}>
            <img className="inline-block w-6 h-6 mr-2" loading="lazy" src={isOpen ? "/icons/minus.svg" : "/icons/plus.svg"} alt="Toggle" />
          {heading}
        </button>
      </div>
      <div 
        ref={contentRef} 
        className={`overflow-hidden transition-height duration-500 ease-in-out h-0 px-3`}>
          <div className={`${contentClass} py-5`} dangerouslySetInnerHTML={{__html: renderRichText(content)}} />
      </div>
    </div>
    ) 
}

const TourNote = ({ blok }) => {
  // console.log(blok)
  // console.log(blok.included)
  
  return (
    <div id="notes" className="pt-10">
      <div className="container max-w-[700px] mx-auto py-10">
        <h2 className="text-3xl font-bold text-center">{Trans('notes')}</h2>
        <div className="py-5 text-center" dangerouslySetInnerHTML={{ __html: renderRichText(blok.noteDescription) }}></div>

        {/* included */}
        {blok.included && <Accordion id="included" heading={Trans('included')} content={blok.included} headColor={'#b2df97'} contentClass={`${styles.tour_include}`} open={true} />}        
        {/* not included */}
        {!blok.hideNotIncluded && <Accordion id="not-included" heading={Trans('notIncluded')} content={blok.notIncluded} headColor={'#ff9b95'} contentClass={`${styles.tour_include} ${styles.tour_not_include}`} />}
        {/* additional info */}
        {blok.noteBody && <Accordion id="additional-info" heading={Trans('additionalInfo')} content={blok.noteBody} headColor={'#fff'} contentClass={`${styles.tour_note_body}`} />}

        {blok.noteBlocks?.map((b) => (
          <StoryblokComponent blok={b} key={b._uid} />
        ))}

      </div>
      
    </div>
  )
};

export default TourNote;
